import { render, staticRenderFns } from "./points.vue?vue&type=template&id=2de974f0&scoped=true"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"
import style0 from "./points.vue?vue&type=style&index=0&id=2de974f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de974f0",
  null
  
)

export default component.exports